import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

interface HubspotFormData {
  email: string;
  firstname?: string;
  lastname?: string;
  company?: string;
  phone?: string;
  message?: string;
  hs_lead_status?: string;
}

export const useHubspotForm = (formId: string) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitToHubspot = async (formData: HubspotFormData) => {
    setIsSubmitting(true);
    
    try {
      const { data, error } = await supabase.functions.invoke("submit-to-hubspot", {
        body: { ...formData, formId },
      });

      if (error) throw error;

      if (data?.success) {
        toast({
          title: "Success!",
          description: "Thank you for your submission. We'll be in touch soon.",
        });
        return true;
      } else {
        throw new Error("Failed to submit form");
      }
    } catch (error: any) {
      console.error("Error submitting to HubSpot:", error);
      toast({
        title: "Error",
        description: "There was a problem submitting your form. Please try again.",
        variant: "destructive",
      });
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { submitToHubspot, isSubmitting };
};
